import App from './App.svelte';

// https://www.consolelog.io/group-by-in-javascript/
Array.prototype.groupBy = function (prop) {
	return this.reduce(function (groups, item) {
		const val = item[prop];
		groups[val] = groups[val] || [];
		groups[val].push(item);
		return groups;
	}, {});
};

const app = new App({
	target: document.body
});

export default app;